<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App",
    components: {},
    // destroyed() {
    //   localStorage.setItem("token", "")
    // },
  };
</script>

<style lang="scss" scoped>
  #app {
    max-width: 750px;
    margin: 0 auto;
  }
</style>
